/* eslint-disable unicorn/no-array-for-each */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store, persistor } from './redux/Store'; // Import persistor from store
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react'; // Import PersistGate
import 'react-toastify/dist/ReactToastify.css';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Validation } from './utils';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

// Get the nonce from the global context
const nonce: string = (globalThis as any).__CSP_NONCE__;

// Create an Emotion cache that uses the nonce
const emotionCache = createCache({
  key: 'emotion',
  nonce: nonce,
  // This is critical - use the global injection function we created
  // This ensures Emotion's styles are always created with the nonce
  //insertionPoint: document.head,
  prepend: true,
});

const queryClient = new QueryClient();

const theme = createTheme();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const AppWrapper = () => (
  <CacheProvider value={emotionCache}>
    <ThemeProvider theme={theme}>
      <ToastContainer position='top-right' />
      <DndProvider backend={HTML5Backend}>
        <App />
      </DndProvider>
    </ThemeProvider>
  </CacheProvider>
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Provider store={store}>
          {Validation.isPersistEnabled() ? (
            <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
              <AppWrapper />
            </PersistGate>
          ) : (
            <AppWrapper />
          )}
        </Provider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
